import React, { useState, useEffect, useRef } from 'react';
import './Notification.scss';
import { connect } from 'unistore/full/react';
import actions from './actions';

export default connect(({ notification }) => {
  return { notification };
}, actions)(Notification);

function Notification({ notification }) {
  const intervalRef = useRef(null);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  useEffect(() => {
    if (notification?.text) {
      setIsNotificationVisible(true);
      clearTimeout(intervalRef.current);
      intervalRef.current = setTimeout(() => {
        setIsNotificationVisible(false);
      }, 3000);
    } else {
      setIsNotificationVisible(false);
    }
  }, [notification?.id]);

  return (
    <div
      className={`Notification ${
        isNotificationVisible ? 'Notification--is-visible' : ''
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100vw"
        fill="none"
        viewBox="0 0 375 64"
        onClick={() => setIsNotificationVisible(false)}
      >
        <g filter="url(#notification-filter)">
          <rect width="359" height="48" x="8" y="8" fill="#fff" rx="4"></rect>
        </g>

        <text
          fill="#121212"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          letterSpacing="0em"
        >
          <tspan x="24" y="36.258">
            {notification?.text}
          </tspan>
        </text>

        <g transform="translate(351.754, 35.275)" pointerEvents="bounding-box">
          {notification?.button}
        </g>

        <defs>
          <filter
            id="notification-filter"
            width="367"
            height="56"
            x="4"
            y="8"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dy="4"></feOffset>
            <feGaussianBlur stdDeviation="2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            ></feBlend>
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            ></feBlend>
          </filter>
        </defs>
      </svg>
    </div>
  );
}
